// extracted by mini-css-extract-plugin
export default {"time":"LiveTime_time__WWfJV"};